import React, { ChangeEvent, useEffect, useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import ru from 'date-fns/locale/ru'
import * as actions from './actions'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'
import { useAlert } from 'react-alert'
import Modal from 'react-modal'
import { InitialState } from './types'
import moment from 'moment'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

import 'react-datepicker/dist/react-datepicker.css'
import './style.css'

registerLocale('ru', ru)

const customModalStyles = {
  content: {
    width: 300,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
}

const linkStyle = {
  borderBottom: '1px dotted blue',
  cursor: 'pointer',
}

export default () => {
  const [title, setTitle] = useState<string>('')
  const [position, setPosition] = useState<number>(0)
  const [availableAt, setAvailableAt] = useState<Date>(new Date())
  const [createModalIsOpen, setCreateModalIsOpen] = useState<boolean>(false)
  const [typeScreen, setTypeScreen] = useState<'first' | 'last'>('first')
  const [titleScreen, setTitleScreen] = useState<string>('')
  const [editIdScreen, setEditIdScreen] = useState<string | false>(false)

  const { id, mid } = useParams<{ id: string; mid: string }>()

  const {
    page,
    screens,
    isFetchingScreens,
    isFetching,
    isProcessSave,
    isProcessRemove,
    error,
  } = useSelector(
    (state: { adminModuleEdit: InitialState }) => state.adminModuleEdit
  )

  const hasFirstScreen = screens.some(screen => screen.type === 'first')
  const hasLastScreen = screens.some(screen => screen.type === 'last')

  const dispatch = useDispatch()
  const alert = useAlert()

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(actions.fetchModule(mid))
    dispatch(actions.fetchModuleScreens(id, mid))
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    setTitle(page.title)
    setPosition(page.position)
    if (page.available_at) {
      setAvailableAt(moment(page.available_at).toDate())
    }
  }, [page])

  const onChangeTitle = (event: ChangeEvent<HTMLInputElement>) => {
    setTitle(event.currentTarget.value)
  }

  const onChangePosition = (event: ChangeEvent<HTMLInputElement>) => {
    setPosition(parseInt(event.currentTarget.value))
  }

  const onChangeTitleScreen = (event: ChangeEvent<HTMLInputElement>) => {
    setTitleScreen(event.currentTarget.value)
  }

  const handleEditModule = () => {
    dispatch(actions.editModule(mid, title, position, moment(availableAt)))
  }

  const handleRemoveModule = () => {
    dispatch(actions.removeModule(mid))
  }

  const handleCreateScreen = () => {
    if (editIdScreen) {
      dispatch(actions.editScreen(id, mid, editIdScreen, titleScreen))
      setCreateModalIsOpen(false)
      setTitleScreen('')
    } else {
      dispatch(actions.createScreen(id, mid, titleScreen, typeScreen))
      setCreateModalIsOpen(false)
      setTitleScreen('')
    }
  }

  const handleOpenEditModal = (
    id: string,
    title: string,
    type: 'first' | 'last'
  ) => {
    setEditIdScreen(id)
    setTitleScreen(title)
    setTypeScreen(type)
    setCreateModalIsOpen(true)
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Редактирование модуля</h2>
        {isFetching ? (
          <span>Загрузка модуля...</span>
        ) : (
          <>
            <label htmlFor={'title'}>Название модуля:</label>
            <br />
            <input
              id={'title'}
              placeholder={'Введите название модуля'}
              value={title}
              onChange={onChangeTitle}
              style={{ marginBottom: 10, width: 200 }}
              required={true}
              autoComplete={'off'}
            />
            <br />
            <label htmlFor={'position'}>Позиция модуля:</label>
            <br />
            <input
              id={'position'}
              type={'number'}
              min={0}
              style={{ marginBottom: 10, width: 200 }}
              onChange={onChangePosition}
              required={true}
              value={position}
            />
            <br />
            <label htmlFor={'date'}>Дата запуска модуля:</label>
            <br />
            <DatePicker
              locale={'ru'}
              selected={availableAt}
              onChange={(date: Date) => setAvailableAt(date)}
              dateFormat={'Pp'}
              showTimeSelect={true}
            />
            <br />
            <br />
            <button onClick={handleEditModule}>Сохранить модуль</button>
            <br />
            <br />
            <button
              style={{ background: 'red', color: '#FFF', opacity: 0.7 }}
              onClick={handleRemoveModule}
              disabled={true}
            >
              Удалить модуль
            </button>
            {screens.length ? (
              <>
                <br />
                <br />
                <table>
                  <thead>
                    <tr>
                      <td>
                        <b>Заголовок</b>
                      </td>
                      <td>
                        <b>Тип</b>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {screens.map(screen => (
                      <tr key={screen.module_screen_id}>
                        <td>
                          <a
                            style={linkStyle}
                            onClick={() =>
                              handleOpenEditModal(
                                screen.module_screen_id,
                                screen.title,
                                screen.type
                              )
                            }
                          >
                            {screen.title}
                          </a>
                        </td>
                        <td>
                          {screen.type === 'first'
                            ? 'Первый экран'
                            : 'Экран завершения'}
                        </td>
                        <td>
                          <Link
                            to={`/admin/courses/${id}/modules/${mid}/module-screen/${screen.module_screen_id}/blocks`}
                          >
                            Настроить содержимое
                          </Link>
                        </td>
                        <td>
                          <button
                            onClick={() =>
                              dispatch(
                                actions.removeScreen(
                                  id,
                                  mid,
                                  screen.module_screen_id
                                )
                              )
                            }
                            style={{ color: '#FFF', background: 'red' }}
                          >
                            X
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <br />
            )}
            <br />
            <button
              disabled={hasFirstScreen}
              style={{ marginBottom: 10 }}
              onClick={() => {
                setCreateModalIsOpen(true)
                setTypeScreen('first')
                setEditIdScreen(false)
              }}
            >
              Добавить первый экран
            </button>
            <br />
            <button
              disabled={hasLastScreen}
              onClick={() => {
                setCreateModalIsOpen(true)
                setTypeScreen('last')
                setEditIdScreen(false)
              }}
            >
              Добавить последний экран
            </button>
            <br />
            <br />
            {error ? <span style={{ color: 'red' }}>{error}</span> : null}
            <br />
            {isProcessSave ? <span>Сохранение модуля...</span> : null}
            <br />
            {isProcessRemove ? (
              <span style={{ color: 'red' }}>Удаление модуля...</span>
            ) : null}
            <br />
            {isFetchingScreens ? <span>Загрузка экранов модуля...</span> : null}
            <Modal
              isOpen={createModalIsOpen}
              onRequestClose={() => setCreateModalIsOpen(false)}
              style={customModalStyles}
              ariaHideApp={false}
            >
              <h3 style={{ margin: 0 }}>
                {editIdScreen ? 'Изменить' : 'Добавить'}{' '}
                {typeScreen === 'first' ? 'первый экран' : 'последний экран'}
              </h3>
              <br />
              <label htmlFor={'title-screen'}>Заголовок:</label>
              <br />
              <input
                style={{ marginTop: 10, width: '90%' }}
                id={'title-screen'}
                value={titleScreen}
                placeholder={'Введите заголовок'}
                onChange={onChangeTitleScreen}
              />
              <br />
              <br />
              <button onClick={handleCreateScreen}>
                {editIdScreen ? 'Сохранить' : 'Создать'}
              </button>
            </Modal>
          </>
        )}
      </div>
      <Footer />
    </>
  )
}
